import VueRouter from 'vue-router'
import {getCookie,setCookie,removeCookie} from '@/utils/auth'
import {getUrlParam} from "@/utils/utitiles"
import Layout from '@/views/layout/index'
import {initUserCompanyApi} from '@/api/common'
import {autoLoginApi,weChatLoginApi} from '@/api/login'
import moment from 'moment'

//路由白名单
const ROUTER_WHITE_LIST=['/login','/register','/aviteuser','/loginavite','/bindingcon'];
const routes = [
  {
    path:'/',
    redirect:'/login'
  },
  {
    path:'/login',
    name:'login',
    component: () => import("../views/login/login")
  },
  {
    path:'/register',
    name:'register',
    component:()=>import('../views/register/register')
  },
  {
    path:'/aviteuser',
    name:'aviteuser',
    component:()=>import('../views/login/aviteuser')
  },
  {
    path:'/loginavite',
    name:'loginavite',
    component:()=>import('../views/login/loginavite')
  },
  {
    path:'/bindingcon',
    name:'bindingcon',
    component:()=>import('../views/login/bindingcon')
  },
  {
    path:'/main',
    name:'main',
    component: Layout,
    children:[{
        path: '/home',
        name: '首页',
        component: () => import("../views/home"),
        meta:{title:'网书智能ERP系统' , url:'/company',showFooter:true}
      },
      {
        path:'/company',
        component:()=>import("../views/company/company"),
        meta:{title:'选择公司' , showFooter:true}
      },
      {
        path:'/search',
        component:()=>import("../views/company/search"),
        meta:{title:'网书智能ERP系统' , url:'/company',showFooter:false}
      },
      {
        path:'/follow',
        component:()=>import("../views/follow/index"),
        meta:{title:'流程' , url:'/home',showFooter:false}
      },
      {
        path:'/takeOff',
        component:()=>import("../views/follow/takeOff"),
        meta:{title:'请假申请',url:'/follow',showFooter:false}
      },
      {
        path:'/business-trip',
        component:()=>import("../views/follow/businessTrip"),
        meta:{title:'出差申请',url:'/follow',showFooter:false}
      },
      {
        path:'/account',
        component:()=>import("../views/follow/expenseAccount"),
        meta:{title:'报销申请',url:'/follow',showFooter:false}
      },
      {
        path:'/work-overtime',
        component:()=>import("../views/follow/workOverTime"),
        meta:{title:'加班申请',url:'/follow',showFooter:false}
      },
      {
        path:'/custom-form',
        component:()=>import("../views/follow/customForm"),
        meta:{title:'自定义',url:'/follow',showFooter:false}
      },
      {
        path:'/approval',
        component: {render: (e) => e("router-view")},
        children:[{
          path:'index',
          component:()=>import("../views/approval/index"),
          meta:{title:'待审批',url:'/home',showFooter:false},
        },{
          path:'detail',
          component:()=>import("../views/approval/detail"),
          meta:{title:'查看详情',url:'/approval/index',showFooter:false}
        },{
          path:'countersign',
          component:()=>import("../views/approval/countersign"),
          meta:{title:'选择加签人',url:'/approval/detail',showFooter:false}
        }]
      },
      {
        path:'/payment',
        component:()=>import('../views/payment/index'),
        redirect:'/payment/mark',
        children:[{
          path:'mark',
          component:()=>import('../views/payment/mark'),
          meta:{title:'记录付款' , url:'/home',showFooter:false},
        },{
          path:'expend',
          component:()=>import('../views/payment/expend'),
          meta:{title:'申请成本外支出' , url:'/home',showFooter:false},
        },{
          path:'search-payment',
          component:()=>import('../views/payment/searchPayment'),
          meta:{title:'查询付款与销账' , url:'/home',showFooter:false},
        },{
          path:'search-expend',
          component:()=>import('../views/payment/searchExpend'),
          meta:{title:'查询成本外支出',url:'/home',showFooter:false},
        }]
      },
      {
        path:'/collection',
        component:()=>import('../views/collection/index'),
        redirect:'/collection/mark',
        children:[{
          path:'mark/:id?',
          component:()=>import('../views/collection/mark'),
          meta:{title:'记录收款' , url:'/home',showFooter:false},
        },{
          path:'search-record',
          component:()=>import('../views/collection/searchRecord'),
          meta:{title:'查询收款与销账' , url:'/home',showFooter:false},
        },{
          path:'report',
          component:()=>import('../views/collection/report'),
          meta:{title:'申报收入外收款' , url:'/home',showFooter:false},
        },{
          path:'search-collection',
          component:()=>import('../views/collection/searchCollection'),
          meta:{title:'查询收入外收款记录' , url:'/home',showFooter:false},
        },{
          path:'from-receive',
          component:()=>import('../views/collection/fromReceivables'),
          meta:{title:'从应收账款中获取' , url:'/home',showFooter:false},
        }]
      },
      {
        path:'/income',
        component:()=>import('../views/income/index'),
        redirect:'/income/main-business',
        children:[{
          path:'main-business',
          component:()=>import('../views/income/main-business'),
          meta:{title:'主营业务收入' , url:'/home',showFooter:false},
        },{
          path:'other-business',
          component:()=>import('../views/income/other-business'),
          meta:{title:'其他业务收入',url:'/home',showFooter:false},
        },{
          path:'operation',
          component:()=>import('../views/income/operation'),
          meta:{title:'营业外收入',url:'/home',showFooter:false},
        },{
          path:'investment',
          component:()=>import('../views/income/investment'),
          meta:{title:'投资收益',url:'/home',showFooter:false},
        },{
          path:'search',
          component:()=>import('../views/income/search'),
          meta:{title:'查询与编辑收入记录',url:'/home',showFooter:false},
        }]
      },
      {
        path:'/material',
        component:()=>import('../views/material/index'),
        redirect:'/material/material-regist',
        children:[{
          path:'material-regist',
          component:()=>import('../views/material/materialRegist'),
          meta:{title:'材料采购登记',url:'/home',showFooter:false},
        },{
          path:'asset-regist',
          component:()=>import('../views/material/assetRegist'),
          meta:{title:'资产采购登记',url:'/home',showFooter:false},
        },{
          path:'product-cancel',
          component:()=>import('../views/material/productCancelRegist'),
          meta:{title:'商品生产与核销登记',url:'/home',showFooter:false},
        },{
          path:'search-material',
          component:()=>import('../views/material/searchMaterial'),
          meta:{title:'材料查询与处置',url:'/home',showFooter:false},
        },{
          path:'search-asset',
          component:()=>import('../views/material/searchAsset'),
          meta:{title:'资产查询与处置',url:'/home',showFooter:false},
        },{
          path:'setting-type',
          component:()=>import('../views/material/setType'),
          meta:{title:'商品与资产类别设置',url:'/home',showFooter:false},
        },{
          path:'setting-name',
          component:()=>import('../views/material/setName'),
          meta:{title:'产品与资产名称设置',url:'/home',showFooter:false},
        },{
          path:'add-type',
          component:()=>import('../views/material/addType'),
          meta:{title:'新建类别' , url:'/home',showFooter:false},
        },{
          path:'edit-type',
          component:()=>import('../views/material/editType'),
          meta:{title:'编辑类别' , url:'/home',showFooter:false},
        }]
      },
      {
       path:'/voucher',
       component:()=>import("../views/voucher/index"),
       meta:{title:'新增凭证',url:'/home',showFooter:false}
      },
      {
       path:'/document',
       component:()=>import("../views/document/index"),
       meta:{title:'文件中心',url:'/home',showFooter:true}
      },
      {
       path:'/mine',
       redirect:'/mine/index',
       component: {render: (e) => e("router-view")},
       children:[{
           path:'index',
           component:()=>import('../views/mineInfo/mine'),
           meta:{title:'我的',showFooter:true},
        },{
          path:'modify-email',
          component:()=>import('../views/mineInfo/modifyMail'),
          meta:{title:'修改邮箱',url:'/mine/index',showFooter:false},
       }]
      },
      {
       path:'/mark',
       component:()=>import('../views/company/mark')
      },
      {
       path:'/getImg',
       component:()=>import('../views/GetImg'),
       meta:{title:'图片中心',showFooter:true}
      },
      {
       path:'/uploadcostedit',
       component:()=>import('../views/costcon/uploadcostedit'),
       meta:{title:'成本与费用',url:'/approval/index',showFooter:false}
      },
      {
       path:'/tax',
       component:()=>import('../views/taxation/index'),
       redirect:'/tax/taxation',
       meta:{title:'记录增值税',url:'/home',showFooter:false},
       children:[{
           path:'taxation',
           component:()=>import("../views/taxation/taxation"),
           meta:{title:'记录营业税金及附加',url:'/tax/taxation',}
        },{
          path:'sale',
          component:()=>import("../views/taxation/salestax"),
          meta:{title:'记录营业税金及附加',url:'/tax/taxation',}
       },{
          path:'month-detail',
          component:()=>import("../views/taxation/VATquery"),
          meta:{title:'查询结果',url:'/tax/taxation'}
       },{
          path:'year-detail',
          component:()=>import("../views/taxation/VATyear"),
          meta:{title:'查询结果',url:'/tax/taxation',}
       }]
      },
      {
        path:'/OfficeCheck',
        component:()=>import("../views/OfficeCheck/index"),
        meta:{title:'考勤打卡' , url:'/home',showFooter:false}
      },
    ]
  }
]

const router = new VueRouter({
  mode:'hash',
  routes,
});
router.beforeEach((to, form, next) => {
  if(to.path.toLowerCase()==="/autologin") {
    removeCookie('LoginInfo');
    let guid = getUrlParam("guid");
    if (guid !== null && guid !== "") {
      let paramItems = {
        guid: guid
      }
      autoLoginApi(paramItems).then(response => {
        if (response.success) {
          let approvalGuid = response.result.ApprovalGUID;
          let targetUrl = "/approval/detail";
          removeCookie('LoginInfo');
          setCookie("LoginInfo", {
            companyId: response.result.C_GUID,
            TargetUrl: targetUrl,
            ApprovalGUID: approvalGuid
          });
          if (response.code === "0000") {
            //判断是否有数据，如果有数据说明是有传参的
            if (response.result && response.result != null) {
              let userCompanyGuid = response.UserCompanyGuid;
              let userInfo = getCookie("UserInfo");
              if (!userInfo) {
                next({
                  path: '/', query: {
                    guid: response.UserCompanyGuid
                  }, replace: true
                });
                return;
              }
              if (userInfo.U_GUID !== response.result.U_GUID) {
                next({
                  path: '/', query: {
                    guid: response.UserCompanyGuid
                  }, replace: true
                });
                return;
              }
              //跳转到待审批页面
              let paramArr = {
                cGuid: response.result.C_GUID,
                uGuid: userInfo.U_GUID,
                userName: userInfo.TelName || userInfo.LoginName
              }
              initUserCompanyApi(paramArr).then(response => {
                if (response.success) {
                  if (response.code === "0000") {
                    setCookie("CompanyInfo", {
                      companyId: response.result.CurrentCompanyGuid,
                      companyName: response.result.Name || response.result.ChineseFullName,
                      loginDate: response.loginDate,
                      dateFormat: response.dateFormat,
                      enterDate: moment(response.result.EnterDate).format('YYYY/MM/DD HH:mm:ss') + '(UTC+8)'
                    });
                    next({
                      path: targetUrl, query: {
                        guid: approvalGuid
                      }, replace: true
                    });
                    return;
                  } else {
                    console.log("公司初始化数据失败");
                    next({
                      path: '/', query: {
                        guid: userCompanyGuid
                      }, replace: true
                    });
                  }
                }
              });
            } else {
              next({
                path: '/', replace: true
              });
            }
          } else if (response.code === "0002") {
            next({
              path: '/aviteuser', query: {
                guid: response.UserCompanyGuid
              }, replace: true
            });
          } else if (response.code === "0003") {
            next({
              path: '/loginavite', query: {
                guid: response.UserCompanyGuid
              }, replace: true
            });
          } else {
            next({
              path: '/', replace: true
            });
          }
        } else {
          next({
            path: '/', replace: true
          });
        }
      })
      return;
    }
    if (ROUTER_WHITE_LIST.includes(to.path)) {
      next({path: "/", replace: true});
      return;
    }
    if (!getCookie('UserInfo')) {
      next({path: "/", replace: true});
      return;
    }
    next({path: "/", replace: true});
    return;
  }
    let code = getUrlParam("code");
    if (code !== null && code !== "") {
      let paramsArr = {
        wechatcode: code
      };
      weChatLoginApi(paramsArr).then(response => {
        if (response.success) {
          if (response.code === "0000") {
            setCookie("UserInfo", {
              U_GUID: response.result.U_GUID,
              LoginName: response.result.LoginName,
              TelName: response.result.TelName,
              NickName: response.result.NickName
            });
            location.href="/#/company";
            return;
          }
          else if (response.code === '0001') {
            sessionStorage.setItem('unionid', response.result.unionId);
            sessionStorage.setItem('openid', response.result.openId);
            sessionStorage.setItem('nickname', response.result.nickname);
            sessionStorage.setItem('area', response.result.area);
            sessionStorage.setItem('headimgurl', response.result.headimgurl);
            sessionStorage.setItem('sex', response.result.sex);
            next();
            return;
          }
          else {
            console.log(response.msg);
            location.href = "/";
            return;
          }
        }
      })
      return;;
    }
    if (ROUTER_WHITE_LIST.includes(to.path)) {
      next();
      return;
    }
    if (!getCookie('UserInfo')) {
      next({path: "/", replace: true});
      return;
    }
    next();
    return;
});
export default router ;
